import { render, staticRenderFns } from "./SubprocessNodeConfig.vue?vue&type=template&id=004f40a6&scoped=true"
import script from "./SubprocessNodeConfig.vue?vue&type=script&lang=js"
export * from "./SubprocessNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./SubprocessNodeConfig.vue?vue&type=style&index=0&id=004f40a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f40a6",
  null
  
)

export default component.exports